import React from 'react';
import PropTypes from 'prop-types';

import VendorRelationTable from './vendor_relation_table';

export default function QuickbooksBrokerVendorTable({ brokers, vendorsById = {} }) {
  if (brokers.length === 0) {
    return <p>No brokers found for this company.</p>;
  }

  return (
    <VendorRelationTable relationType="Broker" showAll={true} users={brokers}  vendorsById={vendorsById} />
  );
}

QuickbooksBrokerVendorTable.propTypes = {
  brokers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    quickbooksId: PropTypes.number,
  })).isRequired,
  // Map of quickbooksId -> { id, displayName } resolved server-side, used to seed each row's select.
  vendorsById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    displayName: PropTypes.string,
  })),
};